import './Login.scss';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { logIn } from 'actions/authentication';
import Button from 'atoms/button';
import Input from 'atoms/input';

export default function LoginInfo() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPasswordl] = useState('');

  const onLogIn = (e) => {
    e.preventDefault();
    dispatch(logIn({ email, password }));
  };

  return (
    <div className="login">
      <h1 className="mr-0">Log in</h1>
      <form onSubmit={onLogIn}>
        <Input
          id="email"
          label="Email"
          onChange={(value) => setEmail(value)}
          value={email}
          autoFocus
        />
        <div className="flex-row justify-between align-center mb-15 mt-35">
          <p className="label">Password</p>
          <Link to="/forgot-password" className="forgot-password">
            Forgot password?
          </Link>
        </div>
        <Input
          id="password"
          type="password"
          onChange={(value) => setPasswordl(value)}
          value={password}
        />
        <span className="no-account-text">
          Don&apos;t have an account?
          <Link to="/signup">Sign up.</Link>
        </span>
        <Button className="mb-35" type="submit" text="Log in" />
      </form>
    </div>
  );
}
